// extracted by mini-css-extract-plugin
export var actionText = "_on-4";
export var container = "_on-0";
export var leftSection = "_on-1";
export var rightSection = "_on-2";
export var settingsButton = "_on-6";
export var settingsIcon = "_on-7";
export var shortcut = "_on-5";
export var shortcutGroup = "_on-3";